<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div class="deskContent">
      <div class="filtro d-flex align-items-center w-100">
        <div
          class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between w-100"
        >
          <div>
            <div class="pt-2 d-md-flex align-items-center ">
              <div class="d-flex align-items-center mr-5 pb-2 pb-md-0">
                <h3 class="tituloPagina  font-weight-bold mb-0">
                  PROMOÇÕES EM DESTAQUE
                </h3>
              </div>
              <div
                v-if="possuiCategoriaSelecionada"
                class="d-flex pt-1 pb-4 pb-md-0"
              >
                <span class="resetFilter" @click="verTodas()"
                  >VER TODAS AS PROMOÇÕES<i class="fa fa-chevron-right pl-2"></i
                ></span>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-start justify-content-md-end deskContent"
          >
            <div
              @click="filtraTipo(item.idTipo, item.selecionado)"
              class="categoria p-2 border  d-flex mr-2"
              :class="item.selecionado ? 'categoria-selecionada' : ''"
              v-for="item in categorias"
              :key="item.idTipo"
            >
              <span class="font-weight-bold">{{ item.nomeTipo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="phoneContent">
      <h3 class="tituloPagina  font-weight-bold mb-0">
        PROMOÇÕES EM DESTAQUE
      </h3>
    </div>

    <div>
      <div v-if="caixasFiltred.length > 0">
        <div class="lista-de-caixas">
          <div v-for="item in caixasFiltred" :key="item.idCaixa">
            <box :box="item"></box>
          </div>
        </div>
        <div class="d-block w-full" v-if="pagina >= qtdPaginasTotal">
          <h5 class="my-3 text-center">Oba! Você viu todas as promos :)</h5>
        </div>
        <div
          class="d-block w-full carregando-promocoes"
          v-if="carregandoPromocoes"
        >
          <h5 class="my-3 text-center">Carregando Promoções...</h5>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col my-3">
          <div></div>
          <div
            type="warning"
            title="Atenção!!"
            active="true"
            class="my-3 alert alert-warning"
            style="height: auto !important"
          >
            Nenhuma Promoção encontrada em: <br />
            <div v-if="categoriaSelecionada">
              <b>Categoria:</b> {{ categoriaSelecionada.nomeTipo }}
            </div>
            <div v-if="palavraChave">
              <b>Palavra Chave:</b> {{ palavraChave }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import box from './box.vue';
import service from './../../services';
import storage from './../../services/storage';
var infiniteScroll = require('vue-infinite-scroll');
export default {
  components: {
    box,
  },
  data() {
    return {
      showHome: false,
      showFooter: true,
      carregando: false,
      carregandoPromocoes: false,
      decoded: {},
      filtro: {},
      caixas: [],
      caixasFiltred: [],
      categorias: [],
      categoriaSelecionada: null,
      palavraChave: null,
      textoFiltro: null,
      possuiCategoriaSelecionada: false,
      pagina: 1,
      qtdPorPagina: 15,
      qtdPaginasTotal: null,
      acabouPaginacao: false,
      iconeCarregando: service.getEnvIconeCarregando(),
      busy: false,
    };
  },
  directives: { infiniteScroll },
  methods: {
    filtraTipo(tipo, selecionado) {
      if (selecionado) {
        this.verTodas();
        return;
      }
      this.possuiCategoriaSelecionada = true;
      this.categorias.forEach(element => {
        element.selecionado = false;
        if (element.idTipo == tipo) {
          element.selecionado = true;
          this.categoriaSelecionada = element;
          this.textoFiltro = 'Categoria - ' + element.nomeTipo;
        }
      });
      this.caixasFiltred = this.caixas.filter(x => x.idTipo == tipo);
      this.filtraPalavraChave();
    },
    loadMore() {
      if (this.pagina < this.qtdPaginasTotal) {
        this.pagina = this.pagina + 1;
        //this.buscarDados();
      }
    },
    retornaLinkLoja() {
      let linkLoja = this.$route.params.loja
        ? this.$route.params.loja
        : storage.lerStorage('linkLoja');

      if (window.location.host.indexOf('clubecerto') >= 0) {
        linkLoja = 'clubecerto';
      }

      return linkLoja;
    },
    async buscarDados() {
      if (this.$route.query.showFooter == 'false') {
        this.showFooter = false;
      }
      if (this.$route.query.showHeader == 'false') {
        this.showHeader = false;
      }

      if (this.pagina == 1) this.carregando = true;

      this.busy = true;
      this.carregandoPromocoes = true;
      const objSend = {
        qtdPorPagina: this.qtdPorPagina,
        pagina: this.pagina,
        linkLoja: await this.retornaLinkLoja(),
      };
      if (this.$route.query) {
        if (this.$route.query.palavra)
          objSend.nomeProduto = this.$route.query.palavra;
        this.palavraChave = this.$route.query.palavra;
      }
      service.getAll('superOfertas', null, 'offers').then(res => {
        const ordenadedItens = (res.data || []).sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);
          return dateB - dateA; // Ordem decrescente, altere para dateA - dateB para ordem crescente
        });
        ordenadedItens.forEach(element => {
          this.caixas.push(element);
          this.caixasFiltred.push(element);
        });

        //this.$scrollTo("#Resultados");
        this.carregando = false;
        this.carregandoPromocoes = false;
        this.busy = false;
      });
    },

    verTodas() {
      this.possuiCategoriaSelecionada = false;
      this.caixasFiltred = this.caixas;
      this.categorias.forEach(tipo => {
        tipo.selecionado ? (tipo.selecionado = false) : '';
      });
    },
    handleWindowScrool(event) {
      const qtdPixels =
        document.documentElement.scrollTop +
        window.innerHeight -
        document.documentElement.offsetHeight +
        600;
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;

      if (
        ((qtdPixels > 0 && qtdPixels < 50) || bottomOfWindow) &&
        this.busy == false
      ) {
        console.log('chegou no fim ');
        this.loadMore();
      }
    },
  },
  async mounted() {
    await this.buscarDados();
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleWindowScrool);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleWindowScrool);
  },
};
</script>
